export default __webpack_public_path__ + "static/media/card1.66bbee9c.png";